import { create } from 'zustand';

/** State needed to restore Site 360 (`/site-details-rr`) after Product Sampling list. */
export type Site360ReturnState = {
	id: unknown;
	app_id_c?: string | null;
	is_dr_required?: boolean;
	stageOfConstruction?: string | null;
};

interface ProductSamplingStore {
	siteDetailAppId: string;
	siteSfid: string;
	/** True when Site 360 stage is Work completed, lost - force closed, or Lost — hides add FAB on list tabs. */
	disabledbtn: boolean;
	/** Set when opening Product Sampling from Site 360; used for header back navigation. */
	site360ReturnState: Site360ReturnState | null;
	stageOfConstruction: string | null;
	typeOfWork: string;
	is_dr_required: boolean;
	setProductSamplingSiteContext: (p: {
		siteDetailAppId?: string;
		siteSfid?: string;
		disabledbtn?: boolean;
		stageOfConstruction?: string | null;
		typeOfWork?: string;
		is_dr_required?: boolean;
	}) => void;
	setSite360ReturnState: (state: Site360ReturnState | null) => void;
	resetProductSamplingStore: () => void;
}

export const useProductSamplingStore = create<ProductSamplingStore>((set) => ({
	siteDetailAppId: '',
	siteSfid: '',
	disabledbtn: false,
	site360ReturnState: null,
	stageOfConstruction: '',
	typeOfWork: '',
	is_dr_required: false,

	setProductSamplingSiteContext: ({
		siteDetailAppId,
		siteSfid,
		disabledbtn,
		stageOfConstruction,
		typeOfWork,
		is_dr_required,
	}): void =>
		set((prev) => ({
			siteDetailAppId: siteDetailAppId !== undefined ? (siteDetailAppId ?? '').trim() : prev.siteDetailAppId,
			siteSfid: siteSfid !== undefined ? (siteSfid ?? '').trim() : prev.siteSfid,
			disabledbtn: disabledbtn !== undefined ? Boolean(disabledbtn) : prev.disabledbtn,
			stageOfConstruction:
				stageOfConstruction !== undefined ? (stageOfConstruction ?? '').trim() : prev.stageOfConstruction,
			typeOfWork: typeOfWork !== undefined ? (typeOfWork ?? '').trim() : prev.typeOfWork,
			is_dr_required: is_dr_required !== undefined ? Boolean(is_dr_required) : prev.is_dr_required,
		})),
	setSite360ReturnState: (site360ReturnState): void => set({ site360ReturnState }),
	resetProductSamplingStore: (): void =>
		set({
			siteDetailAppId: '',
			siteSfid: '',
			disabledbtn: false,
			stageOfConstruction: '',
			typeOfWork: '',
			is_dr_required: false,
			site360ReturnState: null,
		}),
}));
